import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

export interface TableSettings {
  column_name: string;
  variable_name: string;
  is_sortable: boolean;
}

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TableComponent implements OnInit {
  @Input() showHeader: Boolean = true;
  @Input() tableParams: Array<TableSettings>;
  @Input() tableData: any;

  displayedColumns: string[] = [];

  constructor() {}

  ngOnInit(): void {
    for(let i = 0; i < this.tableParams.length; i++){
      this.displayedColumns.push(this.tableParams[i]['variable_name']);
    }
  }
}
